import { useId } from "react";

import { ContributionContext, ContributionProps } from "./context";
import { ContributionCard } from "./card";

function Contribution(props: ContributionProps) {
  const uniqueId = useId();
  const { headingId, descriptionId } = props;

  const modifiedProps = {
    ...props,
    headingId: headingId ?? `${uniqueId}-heading`,
    descriptionId: descriptionId ?? `${uniqueId}-description`
  };

  return (
    <ContributionContext.Provider value={modifiedProps}>
      <ContributionCard />
    </ContributionContext.Provider>
  );
}

export { Contribution };
